export default __webpack_public_path__ + "9cd77d2e45cee20eac3f1a57f7b5cdf9.svg";